import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import {
  AADHAAR_OR_SSN_MASTER,
  PASSPORT_OR_OCI_MASTER,
  applicantStatusMasters,
  isNaturalParent,
  YES_NO_MASTER,
  ENABLE_FAMILY_FOLIO,
} from '../../utils/constant';
import {
  checkApplicantNri,
  checkApplicantResident,
  isAadhaarSelected,
  isFatherMother,
  isOnboardingTypeMinor,
  isPassportSelected,
} from '../../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { styles } from '../../Styles/styles';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  fullWidth = false,
}: {
  title: string | undefined;
  description?: string[] | string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails> {description || description === 0 ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  applicants = [],
  modeOfHolding,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
}): JSX.Element {
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding || 'Single'}
                </Typography>
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {isOnboardingTypeMinor(applicant?.onboardingType || '')
                      ? 'Contributor Details of Guardian'
                      : title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue title={'Age'} description={applicant.age} />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      <KeyValue
                        title={'Status'}
                        description={
                          applicant.statusSubType
                            ? applicantStatusMasters[applicant.statusSubType]
                            : applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      />
                      <KeyValue
                        title={'Nationality of Applicant'}
                        description={applicant.nationality}
                      />
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )}
                      {/* <KeyValue
                        title={'Aadhaar Number/SSN'}
                        description={AADHAAR_OR_SSN_MASTER[applicant.aadhaarOrSsn || '']}
                      /> */}
                      {checkApplicantResident(applicant.status || '') && (
                        <KeyValue
                          title={'Aadhaar Number of Investor'}
                          description={applicant.aadhaarNumber}
                        />
                      )}
                      {/* {applicant.aadhaarOrSsn &&
                        !isAadhaarSelected(applicant.aadhaarOrSsn || '') && (
                          <KeyValue
                            title={'SSN number of NRI/NRI(PIO)'}
                            description={applicant.ssn}
                          />
                        )} */}

                      {checkApplicantNri(applicant.status || '') && (
                        <KeyValue
                          title={'Passport or OCI'}
                          description={PASSPORT_OR_OCI_MASTER[applicant.passportOrOci || '']}
                        />
                      )}
                      {isPassportSelected(applicant.passportOrOci || '') && (
                        <KeyValue title={'Passport of Investor'} description={applicant.passport} />
                      )}
                      {applicant.passportOrOci &&
                        !isPassportSelected(applicant.passportOrOci || '') && (
                          <KeyValue title={'OCI of Investor'} description={applicant.oci} />
                        )}
                      {ENABLE_FAMILY_FOLIO && (
                        <KeyValue
                          title={'Is Family Group Folio'}
                          description={
                            applicant.isFamilyFolio !== null &&
                            applicant.isFamilyFolio !== undefined
                              ? applicant.isFamilyFolio
                                ? 'Yes'
                                : 'No'
                              : '-'
                          }
                        />
                      )}
                      {ENABLE_FAMILY_FOLIO && applicant.isFamilyFolio && (
                        <KeyValue
                          title={'Family Group Folio Number'}
                          description={applicant.familyFolioNumber}
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                  {isOnboardingTypeMinor(applicant?.onboardingType || '') && (
                    <>
                      <SubHeading
                        sx={{
                          color: 'common.black',
                          letterSpacing: 0.5 + 'px',
                          padding: { xs: '10px 10px', sm: '10px 30px' },
                        }}>
                        Contributor Details of Minor Applicant
                      </SubHeading>
                      <Gridstyles>
                        <Grid
                          item
                          container
                          pb={5}
                          rowSpacing={6}
                          columnSpacing={13}
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-start">
                          <KeyValue title={'PAN'} description={applicant.minorPan} />
                          <KeyValue
                            title={'Date of Birth'}
                            description={formatShortDate(applicant.minorDOB)}
                          />
                          <KeyValue title={'Full Name'} description={applicant.minorName} />
                          <KeyValue title={'Father Name'} description={applicant.minorFatherName} />
                          <KeyValue title={'Gender'} description={applicant.minorGender} />
                          <KeyValue title={'Email ID'} description={applicant.minorEmail} />
                          <KeyValue
                            title={'Mobile Number'}
                            description={
                              applicant.minorCountryCode && applicant.minorMobile
                                ? applicant.minorCountryCode + '-' + applicant.minorMobile
                                : applicant.minorMobile
                            }
                          />
                          <KeyValue
                            title={'Relationship with Guardian'}
                            description={applicant.guardianRelationship}
                          />
                          {isFatherMother(applicant.guardianRelationship || '') && (
                            <KeyValue
                              title={'Natural Parents'}
                              description={isNaturalParent[applicant.naturalParent || '']}
                            />
                          )}
                        </Grid>
                      </Gridstyles>
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
